import { render, staticRenderFns } from "./TimeoffApproversSettingHRM.vue?vue&type=template&id=7b53058d&"
import script from "./TimeoffApproversSettingHRM.vue?vue&type=script&lang=js&"
export * from "./TimeoffApproversSettingHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports